/* template */
<template><div><div :class="({        'bxgp': item.type === 1,        'tgwu': item.type === 2,      })" v-for="(item, index) in (rightsInfo)" :key="item.title" class="single-service-item"><div class="single-up"><div class="single-left"><div class="single-title">{{item.title}}</div><div class="single-price">{{+(item.fee / 100).toFixed(2)}}元/份</div></div><div class="single-right"><mpx-image src="https://ut-static.udache.com/webx/sfc/gCGiGAe_2xT7MJvASf3PL_suggest-icon.png" class="suggest-text" v-if="(item.type === 2 && item.type !== selectedType)"/><mpx-view :class="({              'single-select-box-yes': item.type === selectedType,            })" @tap="selectService(item)" class="single-select-box"><spring-icon h="18" w="18" color="#fff" name="checkbox-check-mark"/></mpx-view></div></div><mpx-view @tap="openRightsDescDrawer(item.type)" class="single-down"><div class="tip-wrap"><div v-for="(tipItem, index) in (item.tips ?? [])" :key="tipItem.tipItem" class="tip"><spring-icon :color="(item.type === 1 ? '#338FFF' : '#773D16')" h="15" w="16" name="marketing-check-mark" :externClass='["check-icon"].join(" ")'/><div :style='[("color: "+(item.type === 1 ? "#666" : "#773D16"))] | transRpxStyle' class="text">{{ tipItem }}</div></div></div><spring-icon h="16" w="8" :color="(item.type === 1 ? 'rgba(102, 102, 102, 0.8)' : 'rgba(119, 61, 22, 0.8)')" name="right-thin-arrow" :externClass='["single-down-arrow-icon"].join(" ")'/></mpx-view></div></div></template>

/* styles */
<style scoped lang="stylus" mpxStyleOptions='{"mid":"m2b54ca37"}'>
  @font-face
    font-family MFYuanHei
    src url('https://ut-static.udache.com/webx/sfc/zFeca_fdUIuxJfpXUFGY5_ZaoZiGongFangYuanHeiTi-2-Medium.otf')
  .single-service-item
    border-radius 8px
    background #FFFFFF
    margin-bottom 10px
    .single-up
      display flex
      justify-content space-between
      padding 14px 12px 0px
      margin-bottom 10px
      .single-left
        display flex
        align-items center
      .single-title
        font-family MFYuanHei
        flex-shrink 0
        font-size 15px
        font-weight normal
        -webkit-background-clip text!important
        -webkit-text-fill-color transparent!important
        background-clip text!important
      .single-price
        font-family PingFang SC
        font-size 11px
        font-weight normal
        line-height 24px
        letter-spacing 0px
        font-variation-settings "opsz" auto
        margin-left 6px
      .single-right
        display flex
        align-items center
        justify-content center
      .suggest-text
        position relative
        right -2px
        width 60px
        height 18px
      .single-select-box
          width 18px
          height 18px
          box-sizing: border-box;
          border-radius 5px
          border: 1px solid #FF6400;
          background #fff
          display flex
          align-items center
          justify-content center
      .single-select-box-yes
        background #FF6400
    .single-down
      position relative
      display flex
      padding 10px
      border-radius 0px 0px 8px 8px
      .tip-wrap
        display flex
        overflow-x auto
        .tip 
          display flex
          flex-shrink: 0;
          align-items center
          .text
            font-size 11px
            line-height 12px
            font-family PingFangSC-Regular
            font-weight 400
            margin-left 3px
            margin-right 8px
      .single-down-arrow-icon
        width 28px
        display flex
        align-items center
        justify-content center
  .bxgp
    .single-up
      .single-title
        background linear-gradient(108deg, #2B7DF7 30%, #82BAFF 120%)
      .single-price
        color #666
    .single-down
      background: linear-gradient(270deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 25%, rgba(255, 255, 255, 0) 84%, #FFFFFF 97%), linear-gradient(180deg, rgba(51, 143, 255, 0.1) 0%, rgba(51, 143, 255, 0) 100%);
  .tgwu
    .single-up
      .single-title
        background linear-gradient(108deg, #FF4000 30%, #FF6400 120%)
      .single-price
        color rgba(119, 61, 22, 0.9)
    .single-down
      background linear-gradient(270deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 32%, rgba(255, 255, 255, 0) 81%, #FFFFFF 100%), linear-gradient(180deg, #FCEFDD 7%, rgba(253, 244, 230, 0.25) 97%)

</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m2b54ca37"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./single-service.mpx.js?isComponent&outputPath=components%2Fsingle-service2b54ca37%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./single-service.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Fsingle-service2b54ca37%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m2b54ca37"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/single-service2b54ca37/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'spring-icon':getComponent(require("../../../../../node_modules/@didi/spring-icon/index/index.mpx?isComponent&outputPath=components%2Findex4d1d0d54%2Findex")),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
